import * as Types from 'src/actions/project/index-person-invested/Types';
import Project from 'src/entities/Project';
import {
  IndexPersonInvestedProjectsAction
} from 'src/actions/project/index-person-invested/IndexPersonInvestedProjects.actions';

export interface IndexPersonInvestedProjectsState {
  projects: Project[];
  loading: boolean;
  error: boolean;
}

const initialState: IndexPersonInvestedProjectsState = {
  projects: [],
  loading: false,
  error: false,
};

export function IndexPersonInvestedProjectsReducer(
  state: IndexPersonInvestedProjectsState = initialState,
  action: IndexPersonInvestedProjectsAction
  ): IndexPersonInvestedProjectsState {
  switch (action.type) {
    case Types.INDEX_PERSON_INVESTED_PROJECTS_ATTEMPT:
      return { ...state, projects: [], loading: true, error: false };
    case Types.INDEX_PERSON_INVESTED_PROJECTS_SUCCESS:
      const projects = action.payload;
      return { ...state, projects: projects, loading: false, error: false };
    case Types.INDEX_PERSON_INVESTED_PROJECTS_FAILURE:
      return { ...state, projects: [], loading: false, error: true };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project/IndexPersonInvestedProjects.reducer.tsx